import { usePermissions } from "@/hooks/use-permissions";
import { useLocalization } from "@/context/localization-context";
import { EvaluationSettingsBoard } from "@/evaluation-settings/evaluation-settings-board";

/** Production thresholds of the evaluation (developer role only; the backend enforces the same). */
export default function EvaluationSettingsPage() {
  const { isDeveloper } = usePermissions();
  const { t } = useLocalization();

  if (!isDeveloper) {
    return (
      <div className="p-4 lg:p-6">
        <div className="rounded-md border border-dashed p-6 text-sm text-muted-foreground">{t("evalSettings.forbidden")}</div>
      </div>
    );
  }

  return <EvaluationSettingsBoard />;
}
